export const automationsCenter = {
  name: "automations-center",
  title: "Automations Center",
  authorize: (s) => s.isAdministrator(),
};
export const appReleases = {
  name: "app-releases",
  title: "App Releases",
  authorize: (s) => s.isAdministrator(),
};
export const catalog = {
  name: "catalog-admin",
  title: "Manage Catalogs",
  authorize: (s) => s.hasPermission("ManageCatalogs"),
};
export const documents = { name: "file-manager", nav: 1, title: "Documents" };
export const fileImports = {
  name: "file-imports",
  title: "File Imports",
  authorize: (s) => s.isAdministrator(),
};
export const formio = {
  name: "formio",
  title: "Form Manager",
  authorize: (s) => s.isAdministrator(),
};
export const formsubmissions = {
    nav: 1,
    name: "formio.forms",
    title: "Form Submissions",
    authorize: (s) => s.isAdministrator(),
};
//export const mediaLibrary = {
//  name: "media-library",
//  title: "Manage Media Library",
//  authorize: (s) => s.hasPermission("ManageMedia"),
//};
export const menuManager = {
  name: "menu-manager",
  authorize: (s) => s.isAdministrator(),
};
export const promotions = {
  name: "promotions",
  title: "Promotions",
  authorize: (s) => s.hasPermission("MaintainPromotions"),
};
export const tagManager = {
  name: "tag-manager",
  title: "Tag Settings",
  authorize: (s) => s.isAdministrator(),
};
export const salesrepGoals = {
  name: "salesrep-goals",
  title: "Rep Goals",
  authorize: (s) => s.isAdministrator(),
};
export const reconciliationSettings = {
  name: "reconciliation-settings",
  title: "Reconcilation Settings",
  authorize: (s) => s.isAdministrator() && s.isShowroom(),
};
export const reconciliationLogs = {
  name: "reconciliation-logs",
  title: "Reconcilation Logs",
  authorize: (s) => s.isAdministrator() && s.isShowroom(),
};
export const registerRetailer = {
  name: "register-retailer",
  title: "Register Retailer",
  authorize: (s) => s.isAdministrator(),
};
export const dealerList = {
  name: "dealer-list",
  title: "Store Locator List",
  nav: 1,
  authorize: (s) => s.isCorpOrAbove(),
};
export const marketList = {
  name: "markets",
  title: "Market List",
  nav: 1,
  authorize: (s) => s.isCorpOrAbove(),
};
export const registrationStatuses = {
  name: "registration-statuses",
  title: "Registration Statuses",
  authorize: (s) => s.isAdministrator(),
};
export const termsList = {
    name: "terms-list",
    title: "Payment Terms",
    authorize: (s) => s.isAdministrator(),
};
export const showcodes = {
  name: "showcode-list",
  title: "Show Codes List",
  authorize: (s) => s.isAdministrator() && s.isShowroom(),
};
export const showroomSettings = {
  name: "showroom-settings",
  title: "Showroom Settings",
  authorize: (s) => s.isAdministrator() && s.isShowroom(),
};
export const users = {
  name: "users",
  title: "Users",
  authorize: (s) => s.hasPermission("MaintainUsers"),
};
export const usergroups = {
  name: "usergroup-list",
  title: "User Groups",
  authorize: (s) => s.hasPermission("MaintainUsers"),
};
export const rolePermissions = {
  name: "role-permissions",
  title: "Users Role Permissions",
  authorize: (s) => s.hasPermission("MaintainUsers"),
};
export const permissionLists = {
  name: "permission-list-manager",
  title: "Users Permission Lists",
  authorize: (s) => s.hasPermission("MaintainUsers"),
};
export const tableAudit = {
  name: "table-audit",
  title: "Record Change Log",
  authorize: (s) => s.isAdministrator(),
};
export const virtualCalls = {
  name: "virtual-call",
  title: "Virtual Calls (beta)",
};

export const transferProspects = {
  name: "transfer-prospects",
  title: "Transfer Prospects",
  clickAction: "TransferProspects",
  authorize: (s) => s.isAdministrator(),
};
export const notes = {
  name: "notes",
  title: "Notes",
  authorize: (s) => s.isAdministrator(),
};
export const messageCenter = {
  nav: 5,
  name: "blog-list",
  title: "Message Center",
  authorize: (s) => s.isAdministrator(),
};
export const jobScheduler = {
  nav: 5,
  icon: "clock",
  name: "job-scheduler",
  title: "Job Scheduler",
  authorize: (s) => s.isCorpOrAbove(),
};
export const jobSchedulerLog = {
  nav: 5,
  icon: "clock",
  name: "job-scheduler-log",
  title: "Job Scheduler Log",
  authorize: (s) => s.isCorpOrAbove(),
};


export default _.sortBy(
  [
    automationsCenter,
    catalog, // TODO: hide subnav on any new route
    dealerList,
        marketList,
    termsList,
    //documents,
    fileImports,
        formio,
        formsubmissions,
    //mediaLibrary,
    //menuManager,
    permissionLists,
    promotions,
    //reconciliationSettings,
    //reconciliationLogs,
    registerRetailer,
    registrationStatuses,
    rolePermissions,
    salesrepGoals,
    //shop,
    showcodes,
    showroomSettings,
    tableAudit,
    //jobScheduler,
    tagManager,
    transferProspects,
    users,
    usergroups,
    notes,
    virtualCalls,
    appReleases,
    messageCenter,
    jobScheduler,
    jobSchedulerLog
  ],
  "title"
);
